import React, { Component } from 'react'
import './groupBrowse.css'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

class GroupBrowse extends Component
{
    static propTypes = {
        currentPosition: PropTypes.number.isRequired,
        count: PropTypes.number.isRequired,
        hasPrevious: PropTypes.bool.isRequired,
        hasNext: PropTypes.bool.isRequired,
        onPrevious: PropTypes.func.isRequired,
        onNext: PropTypes.func.isRequired,
    }

    render()
    {
        const { currentPosition, count, onNext, onPrevious, hasPrevious, hasNext, t } = this.props

        return (
            <div className='group-browse'>
                <button onClick={onPrevious} className={classNames({'disabled': ! hasPrevious}, 'fa fa-angle-left')} title={t('visualizer:pagination.previous')} />
                <div className='pagination'>
                    {t('visualizer:type.group')} {currentPosition}/{count}
                </div>
                <button onClick={onNext} className={classNames({'disabled': ! hasNext}, 'fa fa-angle-right')} title={t('visualizer:pagination.next')} />
            </div>
        )
    }
}

export default withTranslation()(GroupBrowse)
